import { http } from 'interfaces'
import { type LutValues } from 'services/lutValuesService'
export interface OrgTypesOption {
  id: number
  descShort?: string
  descLong?: string
  typeCode?: string
}

export interface OrgTypesLutValues extends LutValues {
  organizationTypes: OrgTypesOption[]
}

export async function orgTypeServerCall (): Promise<OrgTypesLutValues> {
  return await http
    .get('/api/v1/organizations/type/').then(value => value.data)
}
